// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"styles_contentBox__w3RBQ"};